module.exports = __webpack_public_path__ + "img/banner2.d14110e2.png";